(function () {
  var pendingOpen = false;
  var pendingTimeoutId = null;
  var PENDING_TIMEOUT_MS = 10000; // how long we'll remember "user wanted cart"

  function clearPendingFlag() {
    pendingOpen = false;
    if (pendingTimeoutId) {
      clearTimeout(pendingTimeoutId);
      pendingTimeoutId = null;
    }
  }

  function openSmartCart() {
    if (
      window.Rebuy &&
      window.Rebuy.SmartCart &&
      typeof window.Rebuy.SmartCart.show === "function"
    ) {
      window.Rebuy.SmartCart.show();
      return true;
    }
    return false;
  }

  function requestSmartCartOpen() {
    // User clicked the icon: remember that we want it open
    pendingOpen = true;

    // Auto-clear after a while so it doesn't randomly open minutes later
    if (pendingTimeoutId) clearTimeout(pendingTimeoutId);
    pendingTimeoutId = setTimeout(clearPendingFlag, PENDING_TIMEOUT_MS);

    // If Smart Cart is already ready, just open now
    if (openSmartCart()) {
      clearPendingFlag();
    }
  }

  function attachCartHandler() {
    var cartButton = document.getElementById("cart-icon-bubble");
    if (!cartButton) {
      console.warn("button-cart-open.js: #cart-icon-bubble not found");
      return;
    }

    cartButton.addEventListener("click", function (event) {
      event.preventDefault();
      requestSmartCartOpen();
    });
  }

  // When Smart Cart announces it's ready, open if user already clicked
  document.addEventListener("rebuy:smartcart.ready", function () {
    if (!pendingOpen) return;

    if (openSmartCart()) {
      clearPendingFlag();
    }
  });

  // Make sure our click handler is attached
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attachCartHandler);
  } else {
    attachCartHandler();
  }
})();